<template>
  <div
    ref="contextMenu"
    class="fixed outline-none z-[9999] cursor-pointer"
    :style="style"
    tabindex="0"
    @blur="$emit('close')"
  >
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      left: this.x,
      top: this.y,
      show: false,
      menuHeight: 50,
      menuWidth: 0,
    };
  },
  computed: {
    isRTL() {
      return this.$root.$i18n.locale === 'he';
    },
    style() {
      let top = this.top;
      if (this.top + this.menuHeight > window.innerHeight) {
        top = window.innerHeight - this.menuHeight - 10;
      }
      let left = this.left - this.width;
      if (left + this.menuWidth > window.innerWidth - 10) {
        left = window.innerWidth - this.menuWidth - 10;
      }
      if (left < 10) {
        left = 10;
      }
      return {
        top: top + 'px',
        left: left + 'px',
      };
    },
    width() {
      if (this.$refs.contextMenu)
        return this.$refs.contextMenu.getBoundingClientRect().width;
      return 0;
    },
  },
  mounted() {
    this.updateStyle();
    this.$nextTick(() => this.$el.focus());
  },
  methods: {
    updateStyle() {
      this.$nextTick(() => {
        if (this.$el) {
          const rect = this.$el.getBoundingClientRect();
          this.menuHeight = rect.height;
          this.menuWidth = rect.width;
          if (this.isRTL) {
            this.left = this.x < rect.width ? this.x : this.x - rect.width;
          }
        }
      });
    },
  },
};
</script>
